<template>
  <el-card class="box-card">
    <div v-if="showHeader" slot="header" class="clearfix">
      <span>{{ typ === 1 ? '分布':'占比' }}</span>
    </div>

    <div ref="chartContainer" style="width: 100%; height: 600px;" />
  </el-card>
</template>

<script>
import { dateStrTodate } from '@/utils'
import echarts from 'echarts'
export default {
  name: 'UserSpinStat',
  props: {
    title: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    typ: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      betMap: [],
      tableData: []
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom',
          bottom: 10
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            // rotate: 45 // 标签旋转45度
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(spinLevelData, data) {
      this.initChart()
      this.tableData = data
      this.betMap = spinLevelData
      if (this.tableData.length <= 0) {
        return
      }

      const betData = {}
      for (let i = 0; i < spinLevelData.length; i++) {
        betData[i] = []
      }

      for (const i in this.tableData) {
        const val = this.tableData[i]
        this.option.xAxis.data.push(dateStrTodate(val.date))
        for (const k in val.data) {
          if (betData[k] !== undefined) {
            betData[k].push(val.data[k].count)
          }
        }
      }

      if (this.typ === 2) {
        const totalMap = {}
        for (const k in betData) {
          const val = betData[k]
          for (const k2 in val) {
            if (totalMap[k2] === undefined) {
              totalMap[k2] = 0
            }
            totalMap[k2] += val[k2]
          }
        }
        for (const k in betData) {
          const val = betData[k]
          const rateData = []
          for (const i in val) {
            const val2 = val[i]
            const rate = val2 / totalMap[i] * 100
            rateData.push(rate.toFixed(2))
          }

          betData[k] = rateData
        }
      }

      for (const i in this.betMap) {
        const val = this.betMap[i]
        this.option.legend.data.push(val)
      }

      for (let i = 0; i < spinLevelData.length; i++) {
        const temp = {
          name: this.betMap[i],
          data: betData[i],
          type: 'line',
          smooth: true
        }

        if (this.typ === 1) {
          temp.type = 'bar'
          temp.itemStyle = {
            barWidth: '10%'
          }
        } else {
          temp.type = 'line'
          temp.itemStyle = {}
        }

        this.option.series.push(temp)
      }

      this.chart.setOption(this.option, true)
    },
    groupStat(data) {
      this.initChart()
      const eData = {}
      const header = {}
      const legend = []
      const date = []
      for (const i in data) {
        const val = data[i]
        date.push(dateStrTodate(val.date))
        for (const k in val.data) {
          const val2 = val.data[k]
          if (eData[val2.group_id] === undefined) {
            header[val2.group_id] = val2.title
            eData[val2.group_id] = []
          }
          eData[val2.group_id].push(val2.count)
        }
      }
      for (const i in eData) {
        const val = eData[i]
        legend.push(header[i])
        const temp = {
          name: header[i],
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
      }
      this.option.xAxis.data = date
      this.option.legend.data = legend
      this.chart.setOption(this.option, true)
    },
    groupDataStat(data) {
      this.initChart()
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 10px
}
</style>
